import { render, staticRenderFns } from "./SaveQuestion.vue?vue&type=template&id=9457106a&"
import script from "./SaveQuestion.vue?vue&type=script&lang=js&"
export * from "./SaveQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports